import { type FilterConfig } from '@analysis/domain';
import { type FilterConfigRepository } from '../../ports';

export interface LoadFilterConfigsPayload {
  protocolId: string;
  userId: string;
}

export class LoadFilterConfigsUseCase {
  constructor(private readonly repository: FilterConfigRepository) {}

  async execute(input: Readonly<LoadFilterConfigsPayload>): Promise<FilterConfig[]> {
    const { protocolId, userId } = input;

    return this.repository.loadAll(protocolId, userId);
  }
}
